import { render, staticRenderFns } from "./WashirPro.vue?vue&type=template&id=8c0e1a16&"
import script from "./WashirPro.vue?vue&type=script&lang=ts&"
export * from "./WashirPro.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports